import React, { useState, useEffect, Fragment } from 'react'

import { Tabs } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, string } from 'prop-types'

import PurchaseList from './Components/PurchaseList/PurchaseList'
import SubscriptionTab from './Components/SubscriptionTab/SubscriptionTab'
import { PURCHASE_TABS, getPurchaseTabs } from './Static/constants'

function Purchases({
  itemsUrl, isYahaha = false, businessName = null, modelId = null, rating = null,
  subscriptionPurchaseFlow = false, isSubscriber = false, subscriptionDownloadsPerMonth = 25,
}) {
  const [activeTab, setActiveTab] = useState(PURCHASE_TABS.all)
  const assignedItemsEnabled = !!businessName

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    if (hash === PURCHASE_TABS.subscription) setActiveTab(PURCHASE_TABS.subscription)
    else if (hash === PURCHASE_TABS.purchased) setActiveTab(PURCHASE_TABS.purchased)
    else if (hash === PURCHASE_TABS.assigned) setActiveTab(PURCHASE_TABS.assigned)
  }, [])

  function handleTabChange(tabId) {
    setActiveTab(tabId)
    window.location.hash = tabId
  }

  const purchaseListProps = {
    itemsUrl,
    isYahaha,
    modelId,
    rating,
  }

  if (!subscriptionPurchaseFlow && !assignedItemsEnabled) {
    return <PurchaseList {...purchaseListProps} syncUrlState />
  }

  return (
    <Fragment>
      <div className="cgt-mb-20">
        <Tabs
          activeTabId={activeTab}
          onClick={handleTabChange}
          tabs={getPurchaseTabs({ subscription: subscriptionPurchaseFlow, assigned: assignedItemsEnabled })}
        />
      </div>
      {activeTab === PURCHASE_TABS.all && (
        <PurchaseList {...purchaseListProps} syncUrlState />
      )}
      {activeTab === PURCHASE_TABS.purchased && (
        <PurchaseList {...purchaseListProps} typeFilter="regular" syncUrlState={false} />
      )}
      {activeTab === PURCHASE_TABS.subscription && (
        <SubscriptionTab
          isSubscriber={isSubscriber}
          modelId={modelId}
          rating={rating}
          subscriptionDownloadsPerMonth={subscriptionDownloadsPerMonth}
        />
      )}
      {activeTab === PURCHASE_TABS.assigned && (
        <PurchaseList {...purchaseListProps} typeFilter="assigned" syncUrlState={false} />
      )}
    </Fragment>
  )
}

Purchases.propTypes = {
  itemsUrl: string.isRequired,
  isYahaha: bool,
  businessName: string,
  modelId: string,
  rating: string,
  subscriptionPurchaseFlow: bool,
  isSubscriber: bool,
  subscriptionDownloadsPerMonth: number,
}

export default Purchases
